import React, { useEffect, useState } from "react";
import { MdRefresh } from "react-icons/md";
import { useRecoilValue } from "recoil";
import { adminProfileState } from "src/atoms/profile.atoms";
import { CONSTANTS } from "src/constants";
import { NotificationProps, ProfileProps } from "src/models/common.model";
import { NavBarProps } from "src/models/layout.models";
import API_SERVICES from "src/services";

import { CContainer, CNavbar, CNavbarToggler } from "@coreui/react";

import notificationImg from "../../../assets/image/notification-mail.svg";
import DrawerComponent from "../Drawer/DrawerComponent";

const Navbar: React.FC<NavBarProps> = ({ ontoggleSidebar, open, setOpen }) => {
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState<
    NotificationProps[] | undefined
  >([]);

  const profile = useRecoilValue<ProfileProps>(adminProfileState);

  useEffect(() => {
    getNotifications();
  }, []);

  const getNotifications = async () => {
    const data = await API_SERVICES.DASHBOARD.GET_JOB_REDIRECTION({
      limit: CONSTANTS.DEFAULT_NOTIFICATION_LIMIT,
    });
    if (data?.items) {
      setNotifications(data.items);
      setNotificationCount(data.items.length);
    }
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      {open && (
        <DrawerComponent
          notifications={notifications}
          open={open}
          setOpen={setOpen}
          setNotifications={setNotifications}
        />
      )}
      <CNavbar colorScheme="light" className="bg-light" data-testid="navbar">
        <CContainer className="dd-sidebar-container" fluid>
          <CNavbarToggler
            aria-controls="navbarToggleExternalContent"
            aria-label="Toggle navigation"
            onClick={() => ontoggleSidebar()}
          />
          <div className="d-flex align-items-center justify-content-center">
            <span className="me-3 fw-bold">{profile?.name}</span>
            <button
              type="button"
              className="dd-circular-button me-2"
              aria-label="Refresh"
              title="Refresh"
              onClick={handleRefresh}
            >
              <MdRefresh size={22} />
            </button>
            <button
              className={`dd-circular-button ${notificationCount > CONSTANTS.DEFAULT_VALUE ? "dd-notification dd-has-notification" : "dd-notification dd-not-has-notification"}`}
              onClick={() => setOpen(!open)}
            >
              <img
                className="w-50"
                src={notificationImg}
                alt="dental dynamic staffing"
              />
            </button>
          </div>
        </CContainer>
      </CNavbar>
    </>
  );
};

export default Navbar;
